// extracted by mini-css-extract-plugin
export var cmlIcon = "styles-module--cmlIcon--749e3";
export var communityPopup = "styles-module--communityPopup--56783";
export var description = "styles-module--description--0e402";
export var dvcIcon = "styles-module--dvcIcon--8c9a2";
export var link = "styles-module--link--cae64";
export var linkIcon = "styles-module--linkIcon--86eb8";
export var otherPopup = "styles-module--otherPopup--a0879";
export var otherToolsPopup = "styles-module--otherToolsPopup--0da21";
export var popup = "styles-module--popup--67bd7";
export var studioIcon = "styles-module--studioIcon--77533";
export var title = "styles-module--title--3574d";
export var titleExternalIcon = "styles-module--titleExternalIcon--eef5d";
export var titleIcon = "styles-module--titleIcon--249e8";
export var visible = "styles-module--visible--b64ad";
export var vscodeIcon = "styles-module--vscodeIcon--4571f";